import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Clock, Target, Rocket, RefreshCw, Gift, FileText, Layout } from 'lucide-react';
const reasons = [{
  icon: <Gift className="text-emerald-600" data-id="element-254" />,
  title: 'BONO 1: Kit de Planificación Express',
  desc: 'El mapa paso a paso para organizar el trimestre en minutos. Incluido GRATIS.'
}, {
  icon: <FileText className="text-emerald-600" data-id="element-255" />,
  title: 'BONO 2: Banco de Rúbricas y Criterios',
  desc: 'Evalúa informes, debates y laboratorios con rigor profesional. Incluido GRATIS.'
}, {
  icon: <Layout className="text-emerald-600" data-id="element-256" />,
  title: 'BONO 3: Pack Clases Interactivas',
  desc: 'Más de 30 plantillas, como tickets de salida, actividades 3-2-1 y debates, para promover la participación de tus estudiantes. Incluido GRATIS.'
}];
export function WhyChoose() {
  return <section className="py-8 md:py-20 px-4 bg-emerald-50/50" data-id="element-257">
      <div className="max-w-6xl mx-auto" data-id="element-258">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-259">
          Además, recibes 3 Bonos Estratégicos
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-260">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-3xl border border-emerald-100 shadow-xl shadow-emerald-900/5 flex flex-col items-center text-center group hover:border-emerald-300 transition-colors" data-id="element-261">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-emerald-50 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-262">
                {cloneElement(reason.icon as React.ReactElement, {
              size: 28
            })}
              </div>
              <h3 className="text-lg md:text-xl font-black text-slate-900 mb-3 leading-tight" data-id="element-263">
                {reason.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base font-medium leading-relaxed" data-id="element-264">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}